module.exports = __webpack_public_path__ + "img/chivas-bottle-mobile.6d97fc03.png";